import FlagsData from './FlagsData';

export default FlagsData;
